export const averageColor = '#f5a524'
export const dangerColor = '#ef4444'
